import React from "react";

export default function BSMLogo() {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <rect
          x="3"
          y="2"
          width="64"
          height="64"
          rx="4"
          fill="white"
          fillOpacity="0.01"
        />
      </g>
      <mask
        id="mask0"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="2"
        width="64"
        height="64"
      >
        <rect x="3" y="2" width="64" height="64" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <rect x="3" y="2" width="64" height="64" fill="#F9812A" />
      </g>
      <path
        d="M54.9199 29.5144C54.8298 29.6822 54.7341 29.8471 54.6483 30.018C53.3057 32.7086 51.9641 35.3987 50.6234 38.0883C50.5123 38.3116 50.3856 38.5259 50.2547 38.7358C49.6102 39.7698 47.9215 39.7938 47.2995 38.6728C46.8773 37.9235 46.5001 37.1606 46.1173 36.3948C45.0225 34.2068 43.9309 32.0177 42.8426 29.8276C42.7948 29.7302 42.7343 29.6418 42.602 29.4185C42.5823 29.7182 42.5612 29.8861 42.5612 30.0569C42.5612 33.5503 42.5527 37.0453 42.5696 40.5387C42.5696 40.9883 42.4542 41.1666 42.0222 41.1232C41.6665 41.0999 41.3098 41.0999 40.9541 41.1232C40.6951 41.1232 40.5811 41.0377 40.5825 40.741C40.5825 36.8519 40.5825 32.9629 40.5924 29.0738C40.5829 28.6104 40.7222 28.1574 40.9873 27.7897C41.2524 27.4221 41.6274 27.1619 42.0503 27.0521C42.9355 26.8482 43.7278 27.2469 44.1964 28.1761C45.6234 31.0236 47.0377 33.8711 48.4619 36.7051C48.5588 36.8571 48.6701 36.9982 48.794 37.1262C48.9178 37.0017 49.0282 36.8629 49.1233 36.7125C50.5484 33.8711 51.9693 31.0281 53.3859 28.1836C53.8517 27.2529 54.6961 26.8348 55.5742 27.0611C56.4524 27.2874 56.9928 28.1101 56.9928 29.1592C56.9928 32.9688 56.9928 36.7785 56.9998 40.5881C56.9998 41.0063 56.89 41.1606 56.4974 41.1232C56.1695 41.0974 55.8402 41.0974 55.5123 41.1232C55.1844 41.1441 55.069 41.0123 55.0733 40.6601C55.0873 39.4267 55.0733 38.1932 55.0733 36.9613C55.0733 34.6683 55.0733 32.3759 55.0733 30.0839C55.0733 29.9056 55.0536 29.7272 55.0423 29.5489L54.9199 29.5144Z"
        fill="white"
      />
      <path
        d="M13.0084 34.0543C13.0084 31.8723 13.0169 29.6917 13 27.5096C13 27.117 13.1041 26.9971 13.4771 27.0001C16.1185 27.015 18.7614 27.0001 21.4028 27.009C23.0353 27.0135 23.9768 28.0162 23.9852 29.7441C23.9852 30.5504 23.9725 31.3567 23.9979 32.163C23.9979 32.3129 24.1386 32.5826 24.2498 32.6126C25.4642 32.8794 25.9498 33.7891 25.9948 34.97C26.0603 36.3097 26.0405 37.6526 25.9357 38.9895C25.8147 40.3488 24.9295 41.0876 23.6137 41.0876C20.7639 41.1011 17.9142 41.0876 15.0645 41.0966C14.548 41.0966 14.0273 41.1161 13.5165 41.1701C13.0802 41.2045 13 41.0187 13 40.6051C13.0183 38.417 13.0084 36.2349 13.0084 34.0543ZM19.3806 34.5264C18.0746 34.5264 16.7687 34.5339 15.4627 34.5264C15.1306 34.5264 14.9786 34.6178 14.9843 35.0045C15.0011 36.2214 14.9983 37.4383 14.9843 38.6553C14.9843 39.0015 15.0954 39.1348 15.4205 39.1333C18.0183 39.1333 20.6148 39.1333 23.2112 39.1244C23.8543 39.1244 24.0865 38.8876 24.1062 38.2252C24.1325 37.294 24.1325 36.3618 24.1062 35.4286C24.0865 34.7572 23.8403 34.5414 23.207 34.5399C21.931 34.5279 20.6556 34.5234 19.3806 34.5264ZM18.5264 32.5961C19.5635 32.5961 20.6021 32.5871 21.6407 32.5961C21.9573 32.5961 22.098 32.4957 22.0896 32.1375C22.0741 31.3627 22.0896 30.5894 22.0896 29.8146C22.0826 29.2151 21.8447 28.9498 21.2649 28.9468C19.3215 28.9348 17.378 28.9468 15.436 28.9378C15.1165 28.9378 14.9857 29.0562 14.9927 29.4099C15.0082 30.3091 15.0096 31.2083 14.9927 32.1075C14.9843 32.4882 15.1236 32.5991 15.4641 32.5946C16.4788 32.5856 17.5033 32.5961 18.5264 32.5961Z"
        fill="white"
      />
      <path
        d="M32.1588 41.1528C30.6291 41.1528 29.1008 41.1408 27.5725 41.1618C27.1785 41.1618 27.0321 41.0344 27.0687 40.6193C27.0962 40.3203 27.0962 40.0191 27.0687 39.7201C27.0307 39.2944 27.194 39.182 27.5782 39.1835C30.3238 39.1985 33.0665 39.1925 35.8164 39.191C37.1153 39.191 37.2236 39.0696 37.2236 37.6789C37.2236 37.015 37.2236 36.351 37.2236 35.6871C37.2138 34.8119 37.0055 34.5931 36.1949 34.5916C33.8645 34.5916 31.534 34.5916 29.2036 34.5916C28.0285 34.5826 27.0392 33.8513 26.8942 32.6433C26.7529 31.4589 26.7567 30.2599 26.9055 29.0765C27.0715 27.8371 28.1397 27.0847 29.4372 27.0787C32.1532 27.0667 34.8693 27.0787 37.5853 27.0682C37.9019 27.0682 38.0075 27.1821 37.9892 27.5088C37.9582 27.9779 38.1158 28.6134 37.8879 28.8726C37.6599 29.1319 37.0618 29.006 36.6213 29.0075C34.35 29.0165 32.08 29.0075 29.8087 29.0075C28.8883 29.0075 28.7195 29.1904 28.7195 30.166C28.7195 30.704 28.7195 31.2406 28.7195 31.7786C28.7195 32.42 28.9474 32.6568 29.5638 32.6568C31.8155 32.6568 34.077 32.6568 36.3328 32.6643C36.7022 32.6578 37.0708 32.7032 37.4291 32.7992C38.4733 33.0989 39.1178 34.0431 39.1389 35.2315C39.1549 36.3376 39.1549 37.4436 39.1389 38.5496C39.1192 40.0033 38.1144 41.1093 36.7466 41.1363C35.2183 41.1663 33.6886 41.1363 32.1603 41.1363L32.1588 41.1528Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="70"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
